module.exports = __webpack_public_path__ + "img/xcx.157341d8.png";